module.exports = "/build/web/svg/matchdays.accd4994de20ecd10036a0904306aa2f.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/matchdays.svg
// module id = 172
// module chunks = 24